import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import FormikForm from "components/shared/FormikForm";
import { addPermissionMetaApi, updatePermissionMetaApi } from "store/actions";
// import Validation from "views/permissions/Validation"; // adjust path/schema as needed

const InputFields = [
  {
    name: "key",
    type: "text",
    label: "Key",
    placeholder: "Key....",
  },
];

export default function AddUpdatePermissionMeta({
  show,
  handleClose,
  handleConfirm,
  title,
  loading,
  rowData,
}) {
  const dispatch = useDispatch();
  const isUpdateMode = !!rowData;

  const [initialValues, setInitalValues] = useState({
    key: rowData?.key || "",
  });
  const [submitLoading, setSubmitLoading] = useState(false); // NEW: own loading state for the API call

  const formRef = React.useRef(null);

  useEffect(() => {
    if (rowData) {
      setInitalValues({
        key: rowData?.key || "",
      });
    }
  }, [rowData]);

  const handleValuesChange = (newValues) => {
    const unchanged = newValues.key === initialValues.key;

    if (unchanged) return;

    setInitalValues({ ...newValues });
  };

  // NEW: builds the payload and calls the API directly from here (same as AddUpdateRole)
  const handleSubmit = (values) => {
    const payload = isUpdateMode
      ? {
          _id: rowData._id,
          key: values.key,
        }
      : {
          key: values.key,
        };

    const action = isUpdateMode ? updatePermissionMetaApi : addPermissionMetaApi;

    setSubmitLoading(true);

    dispatch(
      action({
        data: payload,
        callBack: (err, response) => {
          setSubmitLoading(false);
          if (err) return;
          handleConfirm(response); // parent just closes modal + refreshes list
        },
      }),
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormikForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
          loading={loading || submitLoading}
          inputFields={InputFields}
          buttonText={"Submit"}
          col={12}
          ref={formRef}
          onValuesChange={handleValuesChange}
        />
      </Modal.Body>
    </Modal>
  );
}